import 'preact';
import 'preact-router';


// WEBPACK FOOTER //
// ./ts/vendor.ts